import { create } from "zustand";
import type { JobInfo } from "@/lib/api";
import type { RecreateReference } from "@/lib/recreate";

interface RecreateState {
  /** Job awaiting restoration into the Studio composer, cleared once applied. */
  pendingJob: JobInfo | null;
  pendingReference: RecreateReference | null;
  requestReference: (reference: RecreateReference) => void;
  clearReference: () => void;
  requestRecreate: (job: JobInfo) => void;
  clearRecreate: () => void;
}

export const useRecreateStore = create<RecreateState>((set) => ({
  pendingJob: null,
  pendingReference: null,
  requestRecreate: (job) => set({ pendingJob: job, pendingReference: null }),
  requestReference: (reference) => set({ pendingReference: reference, pendingJob: null }),
  clearReference: () => set({ pendingReference: null }),
  clearRecreate: () => set({ pendingJob: null, pendingReference: null }),
}));
